<template>
  <div>
    <button @click="showLoginPage()">登陆/注册</button>
  </div>
 
</template>
<script>
export default {
  name: 'LoginButton',
  methods: {
    showLoginPage() {
      this.$emit('setShowLogin',true) 
    }
  }
}
</script>
<style scoped>
    button{
        background-color: #ffffff;
        width:136px;
        height: 58px;
        font-family: PingFang SC;        
        font-size: 20px;
        color: #326BFF;
        border: 0px ;
        border-radius: 5px;
        cursor: pointer;
        z-index: 10;
    }
    button:hover {
      background-color: #0056b3;
      color: white;
    }

</style>